<template>
  <div class="about-page">
    <!-- Banner -->
    <div class="page_about_banner">
      <img src="/images/page_about_banner.jpg">
      <div>
        <h2>华合半导体•全球化合物芯片IP领域的引领者
          <br><br>
          致力于打造各类化合物半导体领域核心芯片 <br>
        </h2>
        <h6>关于我们</h6>
      </div>
    </div>

    <!-- 关于我们内容 -->
    <div class="page_about">
      <div class="p-about-txt">
        <h3>
          <span>关于我们</span>
          <font>
            <p style="text-indent: 2em;text-align: left;">
              <span style="font-family: 宋体, SimSun;">华合半导体致力于微波、毫米波化合物单片集成电路的研发、生产和测试等服务。技术团队主要来自于国内大所等，核心团队从业经验均超过10年，在器件设计、器件建模、电路设计、芯片测试、封装等方面有多年的丰富经验和技术积累。随着与国内外代工大厂的紧密联系，新器件、新工艺、新材料的研发生产过程中也有着广泛的合作。</span>
              <span style="font-family: 宋体, SimSun;">公司依托完整的半导体产业链资源，致力于为客户提供半导体全产业链业务服务，包括IP设计服务、模型建模、PDK设计、晶圆级自动化测试及封测代工、应用解决方案支持等服务，以一站式的整合服务方案、全行业最优的性价比、快速的生产能力、高品质的产品满足客户多样化需求。</span>
            </p>
          </font>
        </h3>
      </div>

      <!-- 相关信息链接 -->
      <div class="p-about-link">
        <h3>相关信息</h3>
        <dl>
          <router-link to="/services">
            <img src="@/assets/images/p-about-link1.jpg">
            <dt><span>服务介绍</span><font>&gt;</font></dt>
          </router-link>
          <router-link to="/news">
            <img src="@/assets/images/p-about-link4.jpg">
            <dt><span>新闻中心</span><font>&gt;</font></dt>
          </router-link>
          <router-link to="/contact">
            <img src="@/assets/images/p-about-link5.jpg">
            <dt><span>联系我们</span><font>&gt;</font></dt>
          </router-link>
        </dl>
      </div>

      <!-- 新闻中心 -->
      <div class="p-about-news">
        <h3>新闻中心</h3>
        <dl>
          <a v-for="(news, index) in newsList" :key="index" @click="goToDetail(news)">
            <img :src="news.newImg">
            <dt>
              <span>{{ news.newNameCn }}</span>
              <font>{{ news.newSynopsisCn }}</font>
            </dt>
          </a>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  metaInfo: {
    title: '关于我们_公司概况_核心优势_南京华合半导体科技有限公司',
    meta: [
      { name: 'description', content: '南京华合半导体科技有限公司致力于微波、毫米波化合物单片集成电路的研发、生产和测试。核心团队从业经验超10年，提供IP设计、模型建模、PDK设计、晶圆级测试等全产业链服务。' },
      { name: 'keywords', content: '关于华合半导体,公司概况,核心优势,合作案例,化合物半导体,芯片研发,南京半导体公司' },
      { name: 'robots', content: 'index,follow' },
      { property: 'og:title', content: '关于我们 - 南京华合半导体科技有限公司' },
      { property: 'og:url', content: 'https://huaheic.com/about' }
    ],
    link: [
      { rel: 'canonical', href: 'https://huaheic.com/about' }
    ]
  },
  data() {
    return {
      newsList: [
      
      ]
    }
  },
  created() {
    this.getNewsList()
  },
  methods: {
    getNewsList() {
      this.$request.get('/wx/news/getListByClassIfy', {
        "newType": "1",
        "currentPage": 1,
        "pageSize": 4
      }).then(response => {
        this.newsList = response.data.records
      }).catch(error => {
        console.log(error)
      })
    },
    goToDetail(news) {
      if (news.newNameEn) {
        window.open(news.newNameEn)
        return
      }
      this.$router.push({
        path: '/news/detail',
        query: { id: news.id }
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 740px) {
    .page_about_banner {
        height: 150px;
        padding-top: 54px;
    }
    
    
}
</style>
